import _ from 'lodash';

import ModalActions from '../actions/ModalActions';
import { GlobalModals } from '../constants/AppConstants';
import FeatureFlagStore from '../stores/FeatureFlagStore';
import LocalStorageHelper from '../helpers/LocalStorage';

const STORAGE_KEY = 'child-smart_card-expiration';

export const checkIfChildSmartCardWillExpireSoon = (smartCard) => {
    if (!FeatureFlagStore.get('enableChildSmartcardTransitioning')) {
        return;
    }

    if (!smartCard) {
        return;
    }

    const isChildWillBeAdultInLessThanAMonth = smartCard.isChild() && smartCard.isActive() && smartCard.willBeAdultInLessThanAMonth();
    if (!isChildWillBeAdultInLessThanAMonth) {
        return;
    }

    const hasShownModal = LocalStorageHelper.getItem(STORAGE_KEY);
    if (hasShownModal) {
        return;
    }

    _.defer(() => ModalActions.open(GlobalModals.CHILD_SMART_CARD_EXPIRATION));

    LocalStorageHelper.setItem(
        STORAGE_KEY,
        true,
        smartCard.getSecondsUntilAdult(),
    );
};



// WEBPACK FOOTER //
// ./src/utils/childSmartCardExpiration.js